<template>
  <div id="J_huoBoxBbb" class="section section3">
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <div id="J_huoBbb" class="huo"></div>
      <div class="content-pos">
        <div class="section3-con up-ani">
          <span class="tit">故事</span>
          <p>被列强围绕的<span class="red">雷欧尼斯</span>虽是小国，</p>
          <p>却向来是一个不能轻视的存在。</p>
          <p>
            其理由是持有「有翼者」所授与的<span class="red">「指环」</span>。
          </p>

          <p class="mt">
            <span class="red">幻兵</span>──也就是能够将思念具现化
          </p>
          <p>并驱使它们战斗的能力，</p>
          <p>对于各国来说就是如此值得忌惮。</p>

          <p class="mt">但是，数度交错的残酷命运</p>
          <p>渐渐地、安静地侵蚀了牵绊、爱，甚至是友情。</p>

          <p class="mt">出生于雷欧尼斯的孪生王子，</p>
          <p>
            <span class="red">蒙特</span>与
            <span class="red">斯特恩</span>也不例外。
          </p>

          <p class="mt">两人之间的恩怨成为了漫长幻影战争的战端。</p>

          <p class="mt">在这块群雄割据的土地上</p>
          <p>闪烁着眩目光芒的水晶</p>
          <p>究竟最后会对谁露出微笑呢？</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getEmptySVG } from "@/libs/svg";
export default {
  name: "Section3",
  data() {
    return {
      emptyImage: getEmptySVG(1920, 1080)
    };
  },
  mounted() {
    const huobox = document.getElementById("J_huoBoxBbb");
    const huo = document.getElementById("J_huoBbb");
    huobox.onmousemove = function(e) {
      const x = (e.clientX * 50) / window.innerWidth;
      const y = (e.clientY * 50) / window.innerHeight;
      huo.style.transform = `translate(${x}px,${y}px)`;
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.section3 {
  position: relative;
  background: url("~@/assets/images/bg_03.jpg") no-repeat center top / cover;
  .section-con {
    position: relative;
  }
  .huo {
    position: absolute;
    top: 0;
    left: 0;
    background: url("~@/assets/images/huo.png") no-repeat center top / cover;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    transition-duration: 1000ms;
    transition-property: transform;
    transform-origin: center center;
    .mixin_com(width, 1920);
    .mixin_com(height, 1080);
  }
  .red {
    .mixin_com(font-size, 25);

    color: #e51b16;
  }
  .tit {
    display: block;
    .mixin_com(width, 256);
    .mixin_com(height, 167);

    margin: 0 auto;
    .mixin_com(margin-bottom, 45);

    text-indent: -9999px;
    background:
      url("~@/assets/images/section3/tit3.png") no-repeat center top /
      cover;
  }
  .section3-con {
    position: absolute;
    top: 0;
    left: 50%;
    .mixin_com(width, 526);
    .mixin_com(line-height, 36);
    .mixin_com(margin-left, -575);
    .mixin_com(padding-top, 75);
    .mixin_com(font-size, 22);
    .mixin_com(letter-spacing, 3);

    color: #fff;
    text-align: center;
  }
  .mt {
    .mixin_com(margin-top, 35);
  }
}
</style>
